import { createFileRoute } from '@tanstack/react-router'
import { unbindCommunicationPush } from '@/features/communications/notifications/device-push'
import { env } from '@/env'
import { LogoutPage } from '@/pages/logout/logout-page'
import { resolveApiUrl, resolvePublicApiUrl } from '@/shared/lib/api-url'

export const Route = createFileRoute('/logout')({
  component: LogoutRoute,
})

let inFlightLogoutRequest: Promise<void> | null = null

export function performLogoutRequest() {
  if (inFlightLogoutRequest) {
    return inFlightLogoutRequest
  }

  inFlightLogoutRequest = Promise.resolve()
    .then(async () => {
      await unbindCommunicationPush().catch(() => {})
      const response = await fetch(
        resolvePublicApiUrl(env.VITE_API_URL, '/api/auth/sign-out'),
        {
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          method: 'POST',
        },
      )

      if (response.ok) {
        window.location.assign('/login')

        return
      }

      if (response.status !== 404) {
        throw new Error(`Logout failed with status ${response.status}.`)
      }

      window.location.assign(resolveApiUrl(env.VITE_API_URL, '/logout'))
    })
    .catch((error: unknown) => {
      inFlightLogoutRequest = null
      throw error
    })

  return inFlightLogoutRequest
}

export function resetLogoutRequestForTests() {
  inFlightLogoutRequest = null
}

function LogoutRoute() {
  return <LogoutPage onLogout={performLogoutRequest} />
}
